export interface BrandOption {
    value: any;
    label: string;
}

export class BrandOptionHelper {

    static create(): BrandOption {
        return {
            value: '',
            label: ''
        };
    }

    static transformFromApi(apiData: Object): BrandOption {
        const brandOption = BrandOptionHelper.create();
        brandOption.value = apiData['MA_CODIGO'].trim();
        brandOption.label = apiData['MA_DESCRIPCION'];
        return brandOption;
    }
}